import { ActionButton } from '@/common/buttons/ActionButton';
import { EntityCommentList } from '@/common/entities/entityComment/EntityCommentList';
import { EntityFileList } from '@/common/entities/entityFile/EntityFileList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { ValList } from '@/common/val/ValList';
import { McdInvLineList } from '@/sc/entities/mcdInv/McdInvLineList';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEntityMgr } from '../../../common/entityFramework/entityView/EntityMgrContext';
import { McdInvClaimPymtList } from '../mcdInvClaimPymt/McdInvClaimPymtList';

export const McdInvDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'info', label: 'Info', content: <EntityForm /> },
    { id: 'dateTracker', label: 'Date Tracker', content: <EntityForm module="sc" entity="MCD_INV_DATE_TRACKER" entityId={entityObj.mcdInvDateTrackerId} /> },
    { id: 'mcdInvSum', label: 'Summary Lines', content: <McdInvLineList mcdInv={entityObj} isCld={false} /> },
    { id: 'mcdInvCld', label: 'CLD Lines', content: <McdInvLineList mcdInv={entityObj} isCld={true} /> },
    { id: 'validation', label: 'Validations', content: <ValList parentEntity="MCD_INV" parentEntityId={entityObj.id} /> },
    { id: 'mcdInvClaimPymt', label: 'Claims & Payments', content: <McdInvClaimPymtList mcdInvId={entityObj.id} /> },
    { id: 'entityFile', label: 'Files', content: <EntityFileList parentEntity="MCD_INV" parentEntityId={entityObj.id} /> },
    { id: 'entityComment', label: 'Comments', content: <EntityCommentList parentEntity="MCD_INV" parentEntityId={entityObj.id} /> }
  ];

  const retrStatuses = ['NOT_READY', 'READY', 'REQUESTED', 'DOWNLOADED'];
  const procStatuses = ['CONVERTED', 'SUBMITTED', 'SCRUBBING', 'SCRUBBED', 'CHECKED', 'CHECK_FAIL', 'SYNCED', 'BUCKETED', 'PRICED', 'DISPUTED'];
  const loadStatuses = ['INIT_ARCHIVED'];

  const lifecyclePluginCode = retrStatuses.includes(entityObj.sumStatus)
    ? 'MCD_INV_RETR_LIFECYCLE_ACTION_PLUGIN'
    : procStatuses.includes(entityObj.sumStatus)
      ? 'MCD_INV_PROC_LIFECYCLE_ACTION_PLUGIN'
      : loadStatuses.includes(entityObj.sumStatus)
        ? 'MCD_INV_LOAD_ACTION_PLUGIN'
        : null;

  const lifecycleTitle = retrStatuses.includes(entityObj.sumStatus)
    ? 'Mcd Inv Retrieval Lifecycle'
    : procStatuses.includes(entityObj.sumStatus)
      ? 'Mcd Inv Processing Lifecycle'
      : loadStatuses.includes(entityObj.sumStatus)
        ? 'Mcd Inv Load'
        : null;

  const lifecycleData = {
    title: lifecycleTitle,
    entity: 'MCD_INV',
    entityId: entityObj.id,
    pluginCode: lifecyclePluginCode
  }

  const deleteCldData = {
    title: 'Delete CLD',
    entity: 'MCD_INV',
    entityId: entityObj.id,
    pluginCode: 'MCD_INV_DELETE_CLD_ACTION_PLUGIN'
  }

  const deleteData = {
    title: 'Delete Invoice',
    entity: 'MCD_INV',
    entityId: entityObj.id,
    pluginCode: 'MCD_INV_DELETE_ACTION_PLUGIN'
  }

  const deleteMnSub = {
    title: 'Undo Invoice Load',
    entity: 'MCD_INV',
    entityId: entityObj.id,
    pluginCode: 'MCD_UNDO_INV_LOAD_ACTION_PLUGIN'
  }

  const augButtons = (buttons) => {
    if (lifecyclePluginCode) {
      buttons.push(<ActionButton data={lifecycleData} toolTip={`Run ${lifecycleTitle}`} icon={fas.faPlay} />);
    }

    // TODO Sanity Check Banner: Please contact Kernel Support
    // TODO A single button that enables a user to either delete or progress an Invoice's CLD from CHECK_FAIL
    if (['READY', 'CONVERTED', 'SUBMITTED', 'SCRUBBED', 'CHECK_FAIL', 'CHECKED'].includes(entityObj.cldStatus)) {
      buttons.push(<ActionButton data={deleteCldData} toolTip="Delete CLD" icon={fas.faCircleXmark} />);
    }

    // TODO Protection for deletion - cannot delete an invoice if a Payment has been started for it?
    buttons.push(<ActionButton data={deleteData} toolTip="Delete Invoice" icon={fas.faCircleXmark} />);
    buttons.push(<ActionButton data={deleteMnSub} toolTip="Undo Invoice Load" icon={fas.faCircleXmark} />);
  }

  return (
    <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />
  )
}